import { Component, QueryList, ContentChildren, Input } from '@angular/core';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';

@Component({
  selector: 'accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {

  @Input() usarAncoras = true;

  @ContentChildren(AccordionItemComponent)
  accordionItems: QueryList<AccordionItemComponent>;

  toggleChildren(childId) {
    if (this.accordionItems) {
      this.accordionItems.forEach(item => {
        if (item.ativo && item.id !== childId) {
          item.toggleAtivo();
        }
      });
    }
  }

  getUsarAncoras() {
    return this.usarAncoras;
  }
}
